import { useLocation } from 'react-router-dom';
import { AppSidebar } from '../AppSidebar';
import { TopNavigation } from '../TopNavigation';
import { AccountScopeBoundary } from '../AccountScopeBoundary';
import { PageChromeProvider, useResolvedPageChrome } from './pageChrome';
import { cn } from '@/lib/utils';

export const CardShell: React.FC<{
  children: React.ReactNode;
  banners?: React.ReactNode;
  onStartTour?: () => void;
  onOpenBilling?: () => void;
}> = ({ children, banners, onStartTour, onOpenBilling }) => (
  <PageChromeProvider>
    <CardShellFrame banners={banners} onStartTour={onStartTour} onOpenBilling={onOpenBilling}>
      {children}
    </CardShellFrame>
  </PageChromeProvider>
);

const CardShellFrame: React.FC<{
  children: React.ReactNode;
  banners?: React.ReactNode;
  onStartTour?: () => void;
  onOpenBilling?: () => void;
}> = ({ children, banners, onStartTour, onOpenBilling }) => {
  const { pathname } = useLocation();
  const chrome = useResolvedPageChrome(pathname);

  return (
    <div className="flex h-svh w-full overflow-hidden bg-app-ground">
      <AppSidebar />

      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden sm:my-3 sm:mr-3">
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden border-0 bg-card shadow-[0_1px_2px_rgba(16,24,40,0.04)] sm:rounded-2xl sm:border sm:border-[#E4E7EC]">
          <TopNavigation
            variant="card"
            title={chrome.title}
            onStartTour={onStartTour}
            onOpenBilling={onOpenBilling}
          />

          {banners ? <div className="shrink-0">{banners}</div> : null}

          <main
            id="app-main-scroll"
            className={cn(
              'relative flex min-h-0 min-w-0 flex-1 flex-col',
              chrome.fill ? 'overflow-hidden' : 'overflow-y-auto overflow-x-hidden scrollbar-reveal-root',
              !chrome.fill && !chrome.bleed && 'px-4 py-5 sm:px-6'
            )}
          >
            <div className="flex min-h-0 min-w-0 flex-1 flex-col">
              <AccountScopeBoundary>{children}</AccountScopeBoundary>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
